import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from '@angular/router';
import {
  ApiConfigService,
  AppConfigService,
  AuthService,
  UuidService
} from 'src/app/services';
import {environment} from 'src/environments/environment';
import {delay, first, Observable, Subscription} from 'rxjs';
import {Store} from "@ngrx/store";
import {
  Config, fetchTasks,
  getConfig,
  initialConfigState,
  initialThemeState,
  initialUserState,
  Theme,
  toggleLoading,
  UserSettings,
} from "../../modules/redux";
import {IBusinessUnit, IBusinessUnitRole} from "../../modules/business-units/models";
import {ToastrService} from "ngx-toastr";
import {IAttestation, INavItem, INote, ITask, LookupType} from "../../models";
import {TermsAndConditionsService} from "../../services/terms-and-conditions/terms-and-conditions.service";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {AttestationService} from "../../services/attestation/attestation.service";
import {AttestationModalComponent} from "../attestation-modal/attestation-modal.component";
import {TermsAndConditionsModalComponent} from "../terms-and-conditions-modal/terms-and-conditions-modal.component";
import {loadLookup} from "../../modules/redux/stores/lookups/lookups.actions";
import {UtilService} from "../../modules/shared/services";
import {ModalSize} from "../../modules/shared/services/util/util.service";
import {UserCardSize} from "../../modules/shared/components";
import {IUserSettings} from "../../modules/settings/models/i-user-settings";
import {toggleNavigating, updateSelectedBusinessUnit, updateSelectedBusinessUnitRole, updateSelectedUserView} from "../../modules/redux/stores/config/config.actions";
import {AppFade} from "../../animations/animations";
import { apiVersion } from 'src/app/models/iApiVersion';
import { DataService } from 'src/app/services/data/data.service';
import { UserSettingsService } from 'src/app/modules/settings/services';
import { NavigationResolver } from 'src/app/resolvers/navigation.resolver';
import { BusinessUnitService } from 'src/app/modules/business-units/services';
import { Title } from '@angular/platform-browser';
import { MandateService } from 'src/app/modules/mandates/services';
import { iMandateResponse } from 'src/app/modules/mandates/models';


@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  animations: [AppFade()],
})
export class NavigationComponent implements OnInit, OnDestroy, AfterViewInit {

  appVersion: string = environment.version + "." + environment.buildNumber;
  buildDate: string = (!!environment.buildDate) ? new Date(environment.buildDate).toLocaleString() : "";

  //redux
  animationState = false;
  config$: Subscription = new Subscription();
  theme$: Subscription = new Subscription();
  apiVersion$ : Observable<apiVersion>;
  selectedBusinessUnit: IBusinessUnit = {} as unknown as IBusinessUnit;
  userSettings: IUserSettings = initialUserState;
  config: Config = initialConfigState;
  theme: Theme = initialThemeState;
  //navigation
  readonly ADMIN_REDIRECT_PATH = '/dashboard';
  readonly REDIRECT_PATH = '/deals';
  //animation
  enterAnim = false;
  exitAnim = false;
  show = true;
  //sidenav
  link = '';
  links: INavItem[] = [];
  //notes
  notes: INote[] = [];

  appEnvironment: string = environment.rondeivu_env_title;
  //view props

  private readonly HEADER_HEIGHT = 64;
  screenHeight = 0;
  //modals
  userCardSize = UserCardSize;

  constructor(
    private store: Store,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private termsService: TermsAndConditionsService,
    private attestationService: AttestationService,
    private dialog: MatDialog,
    public util: UtilService,
    public dataService: DataService,
    private userSettingsService: UserSettingsService,
    private apiConfigService: ApiConfigService,
    private title: Title,
    private authService: AuthService,
    private businessUnitService: BusinessUnitService,
    private appConfigService: AppConfigService,
    private mandateService: MandateService
  ) {

    // set the api Version, it will get it on the html via ASYNC pipe
    this.apiVersion$ = this.apiConfigService.getVersion();

    // this.cognitoUser = this.dataService.cognitoUser;
    // console.log("RESOLVERS constructors -->", this.activatedRoute.snapshot.data);

    
    // get navigation items
    this.appConfigService.getNavigationItems().subscribe({
      next: (navItems: INavItem[]) => {
        // console.log("Got navigation items", navItems);
        // only display items that are Enabled and NOT Hidden
        this.links = navItems.filter(x => x.hidden == false);

        // get the first nav that is enabled
        let enabledNavs = this.links.filter(x => x.enabled);

        if (enabledNavs.length == 0) {
          // there are no enabled navs
          this.toastr.error("There are no enabled Navigation items for this user.");
          // this.router.navigate([this.selectedBusinessUnit.slug, 'error']);
          // this.util.sendUserToErrorPage("There are no enabled Navigation items for this user. Please contact support.");
          return;
        }

        const urlSplitWithQueryParam = this.router.url.split('?');
        // const queryParamsStr = urlSplitWithQueryParam.length > 1 ? urlSplitWithQueryParam[1] : '';
        const urlSplt = urlSplitWithQueryParam[0].split('/').filter(x => !!x);

        if (urlSplt.length == 1) {
          // no nav has been selected
          let enabledNavs = this.links.filter(x => x.enabled);

          setTimeout(() => {
            this.navigateToNavItem(enabledNavs[0]);
          })
        }

      }, error: (err: any) => {
        console.error("Error getting navigation items", err);
        this.toastr.error("Error getting navigation items");
      }
    });



    // get selected business unit
    var buSlug = this.activatedRoute.snapshot.paramMap.get("id");
    this.selectedBusinessUnit = this.dataService.businessUnits.filter(x => x.slug == buSlug)[0];
    // console.log("-----> Selected Business Unit:", this.selectedBusinessUnit);
    this.dataService.setCurrentBusinessUnit(this.selectedBusinessUnit);

    // get permissions
    this.title.setTitle(environment.rondeivu_app_title + " | " + (this.selectedBusinessUnit.businessUnitType == "ADMIN" ? 'ADMIN' : this.selectedBusinessUnit.displayName));

    this.store.dispatch(updateSelectedBusinessUnit({businessUnit: this.selectedBusinessUnit}));
    this.store.dispatch(updateSelectedUserView({view: this.selectedBusinessUnit.businessUnitType}));

    const employeeId = this.selectedBusinessUnit.employeeId || '';

    // console.log("Employee Id is ", employeeId);
    this.dataService.currentEmployeeId = employeeId;

    this.businessUnitService.getEmployeePermissions(employeeId).subscribe({
      next: (role: IBusinessUnitRole) => {
        // console.log("Employee Permissions", role)

        // dispatch the role & permissions to store
        this.store.dispatch(updateSelectedBusinessUnitRole({businessUnitRole: role}));
        
        // put the role into data service
        this.dataService.setEmployeePermissionsByRole(role);
      }
    });
    


    // stop the loader spinner (it may have been activated by another component that resolved to this)
    this.util.loader(false);

    if (this.selectedBusinessUnit != null) {
      this.store.dispatch({type: fetchTasks});

      // first get the Terms & Conditions, then the Attestation
      this.getTermsConditionsThenAttestation();
    }

    // user settings
    // this.userSettings = this.activatedRoute.snapshot.data['userSettings'] as IUserSettings;
    // this.dataService.setAppUser(this.userSettings);
    
    // only display items that are Enabled and NOT Hidden
    // let navItems: INavItem[] = this.activatedRoute.snapshot.data['navigation'] as INavItem[] || [];
    // this.links = navItems.filter(x => x.hidden == false);

    // // get the first nav that is enabled
    // let enabledNavs = this.links.filter(x => x.enabled);

    // if (enabledNavs.length == 0) {
    //   // there are no enabled navs
    //   this.toastr.error("There are no enabled Navigation items for this user.");
    //   // this.router.navigate([this.selectedBusinessUnit.slug, 'error']);
    //   // this.util.sendUserToErrorPage("There are no enabled Navigation items for this user. Please contact support.");
    //   return;
    // }
    
    // subscribe to config
    this.config$ = this.store.select(getConfig).subscribe((configState: Config) => {
      this.config = configState;
      if (this.config?.show_navigation_toolbar) {
        this.screenHeight = screen.height - this.HEADER_HEIGHT;
      } else {
        this.screenHeight = screen.height
      }
    });
  }

  ngOnInit() {
    this.animationState = true;
    this.store.dispatch(loadLookup({lookup: LookupType.Private}));

    // manage the action from query params
    var action = this.activatedRoute.snapshot.queryParamMap.get("action");
    if (action == 'deal-interest') {
      // open the deal interest modal
      // get the deal Id
      var dealId = this.activatedRoute.snapshot.queryParamMap.get("dealId");

      if (!!dealId) {
        // Go to the preview for the deal
        this.router.navigate(['deal-preview', dealId]).then(() => {
          this.toastr.info("Please express your interest in the deal from the preview page.");
        });
      }
    }

    // get user Settings (user Info)
    this.userSettingsService.getUserSettings().subscribe({
      next: (res: IUserSettings) => {
        this.userSettings = res;  
        this.dataService.setAppUser(this.userSettings);
        this.toastr.success(`Welcome, ${this.userSettings.firstName}!`, $localize`:@@companyName:Rondeivu`);
      },
      error: (err: any) => {
        console.error("Error getting user settings", err);
        this.toastr.error("Error getting user settings");
        this.util.sendUserToErrorPage("Error getting user settings. Please try again in a few minutes.");
        }
    });
  }

  ngOnDestroy() {
    this.theme$.unsubscribe();
    this.config$.unsubscribe();
  }

  ngAfterViewInit() {
    // If NAV not selected, then select a nav
    
  }

  logOut() {
    this.ngOnDestroy();
    this.util.logOut().then(() => {
      console.log("Logged User Out");
    });
  }

  getTermsConditionsThenAttestation() {
    this.termsService.getTermsAndConditions().pipe(first()).subscribe({
      next: (res: { termsAndConditionsRequired: boolean, bodyHtml: string, pdfDownloadLink: string }) => {
        // console.log("T&C result", res);
        if (res?.termsAndConditionsRequired) {
          this.dialog.open(TermsAndConditionsModalComponent, {
            // height: '80vh',
            width: this.util.getModalWidth(ModalSize.LARGE),
            backdropClass: "black-out-modal",
            disableClose: true,
            data: res
          })
          .afterClosed().subscribe(result => {
            if (!!result) {
              this.termsService.signTermsAndConditions().subscribe((res: any) => {
                this.toastr.success("Terms and Conditions Signed!", $localize`:@@companyName:Rondeivu`);
                if (this.util.isInvestor()) {
                  this.getAttestation();
                }
              });
            }
          });
        } else {
          if (this.util.isInvestor()) {
            this.getAttestation();
          }
        }
      }, 
      error: (err) => {
        console.error("T&C Error", err);
        this.util.logOut(true).then(() => {
          this.toastr.error("There was an error with your Terms and Conditions. Please get in touch with Rondeivu Admin.", $localize`:@@companyName:Rondeivu`);
        });
      }
    });
  }

  /**
   * Creates the attestation modal and handles signing
   */
  getAttestation() {
    // console.log("Get Attestation");
    this.attestationService.getAttestation().pipe(first()).subscribe({
      next: (res: IAttestation) => {
        // console.log("Attestation results", res);
        if (res?.attestationRequired) {
          this.dialog.open(AttestationModalComponent, {
            maxHeight: '80vh',
            height: 'auto',
            width: this.util.getModalWidth(ModalSize.MEDIUM),
            backdropClass: "black-out-modal",
            disableClose: true,
            data: res
          })
          .afterClosed().subscribe(result => {
            if (!!result) {
              // console.log("Dialog closed with payload!");
              this.attestationService.signAttestation().subscribe((res: any) => {
                this.toastr.success("Thank you, Welcome to Rondeivu!", $localize`:@@companyName:Rondeivu`);
                // check mandate
                this.checkMandateToOpenModal();
              });
            }
          });
        }
        else {
          console.log("No Attestation required");
          // no attestation required, open the mandate modal
          this.checkMandateToOpenModal();
        }
      },
      error: (err) => {
        console.error("Attestation Error", err);  
        this.util.logOut(true).then(() => {
          this.toastr.error("There was an error with your Attestation. Please get in touch with Rondeivu Admin.", $localize`:@@companyName:Rondeivu`);
        });
      }
    });
  }

  checkMandateToOpenModal() {
    this.mandateService.getMandates().pipe(first()).subscribe({
      next: (mandates: iMandateResponse[]) => {
        console.log("Mandates fetched", mandates);

        // only open the mandate modal if there are no mandates
        if (mandates.length == 0) {
          this.mandateService.openMandateModal();
        }
      }
    });
  }

   
  /**
   * User selects a business unit
   * @param businessUnit
   */
  selectBusinessUnit(businessUnit: IBusinessUnit) {
    if (businessUnit.isEmployeeActive == false) {
      this.toastr.error("You do not have access to this Business Unit, as you are temporarily suspended.")
      return;
    }
    this.store.dispatch(toggleLoading({loading: true}));
    this.router.navigate([ businessUnit.slug ]).then(() => {
      this.toastr.success(`Now acting as '${businessUnit.displayName}'`);
      this.store.dispatch(toggleLoading({loading: false}));
      window.location.reload();
    });
  }

  /**
   * Helper funcion to get the row color as determined by business unit selection
   * @param b selected business unit
   */
  getRowColor(b: IBusinessUnit): string {
    return b.businessUnitId === this.selectedBusinessUnit.businessUnitId ? 'whitesmoke' : '';
  }

  navigateToUserSettings() {
    this.router.navigate([this.dataService.getBuSlug(), 'settings']).then(() => {
      // this.toastr.info("Navigated to User Profile");
    });
  }

  /**
   * Navigate to the route according to the task
   * @param task
   */
  goToTask(task: ITask) {
    let link = ''
    if (!!task) {
      // if an action exists then dispatch it
      if (!!task.action) {
        this.store.dispatch({type: task.action});
      }
      // routing construction
      if (!!task.businessUnitSlug && !!task.route) {
        link = task.businessUnitSlug + '/' + task.route;
        if (!!task.routeId) {
          link += '/' + task.routeId;
          if (!!task.fragment) {
            link += '/' + task.fragment;
          }
        }
        if (!!task.fragment) {
          this.toastr.warning("Task Error: No Object Id", $localize`:@@companyName:Rondeivu`);
        }
      } else {
        this.toastr.warning("Task Error: No Business Unit", $localize`:@@companyName:Rondeivu`);
      }
      // task routing
      if (link != '') {
        if (!!task.queryParams) {
          this.animationState = false;
          this.store.dispatch(toggleNavigating({navigating: true}));
          setTimeout(() => {
            this.router.navigate([link], {queryParams: task.queryParams}).then(() => {
              this.store.dispatch(toggleNavigating({navigating: false}));
              this.animationState = true;
            });
          }, 500);
        } else {
          this.animationState = false;
          this.store.dispatch(toggleNavigating({navigating: true}));
          setTimeout(() => {
            this.router.navigate([link]).then(() => {
              this.store.dispatch(toggleNavigating({navigating: false}));
              this.animationState = true;
            });
          }, 500);
        }
      }
    }
  }

  getTaskBg(task: ITask) {
    // switch on status
    switch (task.status?.toLowerCase()) {
      case 'task':
        return this.theme.tasks.task;
      case 'complete':
        return this.theme.tasks.complete;
      case 'pending':
        return this.theme.tasks.pending;
      case 'info':
        return this.theme.tasks.info;
      default:
        return '';
    }
  }

  getTaskImage(status: string) {
    // switch on status
    switch (status?.toLowerCase()) {
      case 'task':
        return 'pending_actions';
      case 'complete':
        return 'task_alt';
      case 'pending':
        return 'schedule';
      case 'info':
        return 'info_outline';
      default:
        return 'pending_action';
    }
  }

  /**
   * The main navigation triggers an animation before routing
   * @param navItem
   */
  navigateToNavItem(navItem: INavItem) {
    console.log("Navigating to ", navItem);
    // return;
    if (navItem.enabled == false || navItem.hidden == true) {
      // this item cannot be accessed by the user
      this.toastr.error("You cannot access this navigation item");
      return;
    }

    // this.store.dispatch(toggleNavigating({navigating: true}));
    this.util.loader(true);
    this.router.navigate([this.dataService.getBuSlug() + navItem.link], { queryParams: navItem.queryParams }).then(() => {
      // this.store.dispatch(toggleNavigating({navigating: false}));
      this.util.loader(false);
    });
  }

  isActiveRoute(navObj: INavItem) : boolean {
    const url = this.router.parseUrl(this.router.url);
    const queryParams = url.queryParams;
    const urlSplt = url.toString().split('?')[0].split('/').filter(x => !!x);

    if (urlSplt.length >= 2 && '/' + urlSplt[1] === navObj.link) {

      // If there are no query params, then return true
      if (Object.keys(queryParams).length == 0) {
        return true;
      }

      // else, check query params too
      return JSON.stringify(queryParams) == JSON.stringify(navObj.queryParams);      
    }

    return false;
  }

  getActiveRouteClass(navObj: INavItem) : string {
    // let isActive = this.isActiveRoute(navObj);
    if (navObj.enabled == false) {
      return 'nav-item nav-item-disabled';
    }

    return this.isActiveRoute(navObj) ? 'nav-item active-title' : 'nav-item';
  }
}
